<template>
  <div class="collect">
    <Head title="我的收藏"></Head>
    <div class="collect_bottm">
      <van-tabs v-model="active" color="#4A79F1">
        <van-tab title-class="tab-item" title="资讯">
          <Seek />
        </van-tab>
        <van-tab title-class="tab-item" title="论文">
          <Paper />
        </van-tab>
        <van-tab title-class="tab-item" title="会议">
          <Meeting />
        </van-tab>
        <van-tab title-class="tab-item" title="课程">
          <Course />
        </van-tab>
        <van-tab title-class="tab-item" title="专著">
          <Monograph />
        </van-tab>
        <van-tab title-class="tab-item" title="图书">
          <Books />
        </van-tab>
        <van-tab title-class="tab-item" title="行业报告">
          <Reports />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import Monograph from "./monograph.vue";
import Paper from "./paper.vue";
import Meeting from "./meeting.vue";
import Course from "./course.vue";
import Seek from "./seekAdviceFrom.vue";
import Head from "../components/headTabs.vue";
import Books from "./books.vue";
import Reports from "./reports.vue";
export default {
  name: "Collect",
  data() {
    return {
      active: 0,
    };
  },
  components: {
    // 专著
    Monograph,
    // 论文
    Paper,
    // 会议
    Meeting,
    // 课程
    Course,
    // 咨询
    Seek,
    // 图书
    Books,
    Head,
    Reports,
  },
  methods: {},
};
</script>

<style lang="scss">
.collect {
  width: 100vw;
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  .collect_bottm {
    background: #f5f5f5;
    .tab-item {
      padding: 0 22px;
    }
  }
}
</style>